import React from "react";

const Working = ({ stubText, regionName }) => {
  return (
    <div className="middle -no-margin">
      <h3>{ `BuzzIQ Summary - ${regionName}` }</h3>
      <span>{stubText}</span>
    </div>
  );
};

export default Working;
